import { BlockModal } from 'app/components/BlockModal';
import React, {createContext, useContext, useState} from 'react';
import history from 'history.js';

const BlockModalContext = createContext({});

export function BlockModalProvider ({ children }) {

    const [isBlockModalVisible, setIsBlockModalVisible] = useState(false);

    function show() {
        setIsBlockModalVisible(true);
    }

    function hide() {
        setIsBlockModalVisible(false);
        history.push("/dashboard");
    }

    return (
        <BlockModalContext.Provider value={{ show, hide }}>

            {children}

            <BlockModal isVisible={isBlockModalVisible} handleClose={hide} />
        </BlockModalContext.Provider>
    );
}

export function useModalBlock() {

    const modal = useContext(BlockModalContext);

    return modal;
}